import Monke from "../../img/2025/Ruso.jpeg";
const Puzzle5 = () => {
  return (
    <main style={{ padding: 24 }}>
      <h1>❄️ 5. Ruso der Russische – Das Logikgitter</h1>

      <p>
        Я Ruso. Kalt wie Sibirien, klar wie Wodka. Ich rede nicht viel. Löse
        mein Rätsel – oder erfriere im Nebel deiner Gedanken.
      </p>
      <img src={Monke} style={{ maxWidth: "100%", marginBottom: "32px" }} />
      <p>
        <b style={{ fontSize: "1.2em" }}>
          Mugo, Jugo und Ruso gingen in den Keller:
          <br />
          Einer trug eine Taschenlampe, einer eine Mütze, einer eine Flasche
          Wodka.
          <br />
          <ul>
            <li>Mugo ist links von Ruso</li>
            <li>Der Wodka ist bereits halb leer</li>
            <li>Ruso hat keine Mütze</li>
            <li>Der mit der Lampe ist rechts von Jugo</li>
          </ul>
          <br />
          An welcher Stelle ist Ruso? (Links 1, Mitte 2, Rechts 3)
        </b>
      </p>
      <p>Jugo ist oben im Estrich. Schau mal vorbei.</p>
    </main>
  );
};

export default Puzzle5;
